import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import * as moment from 'moment';
import { NumberTranslatePipe } from '@app/shared/pipes/number-translate.pipe';

@Component({
  selector: 'app-health-check-card',
  templateUrl: './health-check-card.component.html',
  styleUrls: ['./health-check-card.component.scss'],
})
export class HealthCheckCardComponent implements AfterViewInit, OnChanges {
  @Input() completionScore: number = 0;
  @ViewChild('healthCheckChart') healthCheckChart?: ElementRef<SVGElement>;

  constructor(private numberTranslatePipe: NumberTranslatePipe) {}

  translate(value: number) {
    return value?.toString &&
      typeof value !== 'object' &&
      !Number.isNaN(parseFloat(value.toString()))
      ? moment.unix(parseFloat(value.toString())).format(value.toString())
      : '';
  }

  ngAfterViewInit(): void {
    this.updateChartValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['completionScore']) {
      this.updateChartValue();
    }
  }

  private updateChartValue(): void {
    const meter = this.healthCheckChart?.nativeElement.querySelector(
      '.meter'
    ) as SVGGeometryElement | null;

    if (!meter) {
      return;
    }

    const length = meter.getTotalLength();
    const trimmedNumber = Math.floor(this.completionScore);
    const to = length * ((100 - trimmedNumber) / 100);
    meter.style.strokeDasharray = length.toString();
    meter.style.strokeDashoffset = Math.max(0, to).toString();
    const val = `${this.numberTranslatePipe.transform(trimmedNumber)}%`;
    if (meter.nextElementSibling) {
      meter.nextElementSibling.textContent = val;
    }
  }
}
